import { render } from "./sesionExpiradaModal.vue?vue&type=template&id=2dd02967&scoped=true"
import script from "./sesionExpiradaModal.vue?vue&type=script&lang=js"
export * from "./sesionExpiradaModal.vue?vue&type=script&lang=js"

import "./sesionExpiradaModal.vue?vue&type=style&index=0&id=2dd02967&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd02967"]])

export default __exports__